if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        this.initVerticalThumbnailNav();

        // Add click-to-advance functionality
        this.elements.viewer.querySelectorAll('.product__media-item').forEach((slide) => {
          slide.style.cursor = 'pointer'; // Make it look clickable
          slide.addEventListener('click', () => {
            // Find the next slide, or loop back to the first if it's the last one
            const nextSlide = slide.nextElementSibling || slide.parentElement.firstElementChild;
            
            if (nextSlide && nextSlide.dataset.mediaId) {
              this.setActiveMedia(nextSlide.dataset.mediaId, false);
            }
          });
        });
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        this.updateDesktopCounter(activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button.thumbnail')
          .forEach((el) => el.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        const ul = this.getThumbnailList();
        if (ul && getComputedStyle(ul).flexDirection === 'column') {
          let offsetTop = 0;
          let el = thumbnail;
          while (el && el !== ul) {
            offsetTop += el.offsetTop;
            el = el.offsetParent;
          }
          ul.scrollTo({ top: offsetTop, behavior: 'smooth' });
        } else if (this.elements.thumbnails.slider) {
          if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      getThumbnailList() {
        return this.querySelector('.thumbnail-list');
      }

      updateDesktopCounter(position) {
        const counter = document.querySelector('.pdp-image-counter .pdp-counter--current');
        if (counter) counter.textContent = position;
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      initVerticalThumbnailNav() {
        if (!this.mql.matches) return;

        const ul = this.getThumbnailList();
        if (!ul) return;

        // Support both new (.pdp-thumb-btn) and old (name=previous/next) button markup
        const prevBtn = this.querySelector('.pdp-thumb-btn--prev') ||
                        this.querySelector('button[name="previous"]');
        const nextBtn = this.querySelector('.pdp-thumb-btn--next') ||
                        this.querySelector('button[name="next"]');
        if (!prevBtn || !nextBtn) return;

        const getScrollStep = () => {
          const firstItem = ul.querySelector('.thumbnail-list__item');
          if (!firstItem) return 324;
          const gap = parseFloat(getComputedStyle(ul).rowGap || getComputedStyle(ul).gap || '8');
          return (firstItem.offsetHeight + gap) * 3;
        };

        // Use capture:true so we always fire before SliderComponent's handler
        // (needed for the old name=previous/next buttons which SliderComponent also binds)
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          ul.scrollBy({ top: -getScrollStep(), behavior: 'smooth' });
        }, { capture: true });

        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          ul.scrollBy({ top: getScrollStep(), behavior: 'smooth' });
        }, { capture: true });
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}